import { Globe, MapPin } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";

/**
 * Compact list of program components (hours, sessions, format).
 * `components` = [{ kind: 'online'|'offline', label, detail }]
 */
export default function ProgramComponents({ components = [], testid = "program-components" }) {
  const reduced = useReducedMotion();
  return (
    <ul
      data-testid={testid}
      className="grid grid-cols-1 sm:grid-cols-2 gap-4"
    >
      {components.map((c, idx) => (
        <motion.li
          key={c.label}
          initial={reduced ? false : { opacity: 0, y: 8 }}
          whileInView={reduced ? undefined : { opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.4, delay: idx * 0.04, ease: [0.16, 1, 0.3, 1] }}
          className="bg-paper rounded-2xl border border-[rgba(74,63,57,0.10)] p-5 flex items-start gap-3"
        >
          <div
            className="w-10 h-10 rounded-xl flex items-center justify-center shrink-0"
            style={{
              backgroundColor:
                c.kind === "online"
                  ? "rgba(200,106,74,0.12)"
                  : "rgba(95,127,107,0.18)",
              color: c.kind === "online" ? "#C86A4A" : "#3f5a4d",
            }}
          >
            {c.kind === "online" ? <Globe className="w-5 h-5" /> : <MapPin className="w-5 h-5" />}
          </div>
          <div className="min-w-0">
            <div className="text-[10.5px] uppercase tracking-[0.18em] text-ink-muted font-semibold">
              {c.kind === "online" ? "Online" : "Offline · Field"}
            </div>
            <div className="font-display text-[15px] sm:text-base text-ink mt-0.5 leading-snug">
              {c.label}
            </div>
            {c.detail && (
              <div className="text-sm text-ink-muted mt-1.5 leading-[1.6]">{c.detail}</div>
            )}
          </div>
        </motion.li>
      ))}
    </ul>
  );
}
